// TrainAxis brand mark — black rounded tile, white dumbbell, red center bar.
// Pure inline SVG so it renders crisp at any size. The tile is intentionally
// theme-INDEPENDENT: it stays black (#141416) in both light and dark mode —
// it's the fixed brand mark, not a themed surface. Matches the app icon at
// frontend/public/icon-512.png.
function BrandLogo({ size = 40, className = '' }) {
  return (
    <svg
      viewBox="0 0 1024 1024"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="TrainAxis"
    >
      <rect x="0" y="0" width="1024" height="1024" rx="230" fill="#141416" />
      <rect x="379" y="456" width="266" height="112" rx="56" fill="#c8102e" />
      <rect x="215" y="246" width="118" height="532" rx="59" fill="#ffffff" />
      <rect x="691" y="246" width="118" height="532" rx="59" fill="#ffffff" />
      <rect x="51"  y="338" width="118" height="348" rx="59" fill="#ffffff" />
      <rect x="855" y="338" width="118" height="348" rx="59" fill="#ffffff" />
    </svg>
  );
}

export default BrandLogo;
